export class AppQueryParams {
  constructor(
    public loggedIn: boolean,
    public lang: string,
  ) {}
}
